export default __webpack_public_path__ + "static/media/reports-7.f805618c.png";